import { render, staticRenderFns } from "./TravelerTypeList.vue?vue&type=template&id=5b2abc5c&scoped=true&"
import script from "./TravelerTypeList.vue?vue&type=script&lang=js&"
export * from "./TravelerTypeList.vue?vue&type=script&lang=js&"
import style0 from "./TravelerTypeList.vue?vue&type=style&index=0&id=5b2abc5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2abc5c",
  null
  
)

export default component.exports